import { usePopup } from "@contexts/popupContext"
import styles from '@styles/components/ResultPopup.module.css'


const ResultPopup = ({ result, succesful }) => {
    const {hidePopup} = usePopup()

    return (
        <div className={styles['popup']} onClick={() => {hidePopup()}}>
            <div className={styles['svg-container']}>
                {succesful ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="9" fill="#EC6C56"/>
                        <path d="M12 7L7.875 11L6 9.18182" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="none">
                    <circle cx="15" cy="15" r="15" fill="#F14239"/>
                    <path d="M19 11L11 19" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11 11L19 19" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                }
            </div>
            <p>{result}</p>
        </div>
    )
}

export default ResultPopup
